import { HOST } from "../constants/HostConstants";

export const promotionAdminDelete = async (promotion_id, reason) => {
  try {
    const response = await fetch(`${HOST}/api/promotion/adminDelete`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ promotion_id, reason }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Failed to delete promotion");
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting promotion:", error);
    throw error;
  }
};
